import translations from '@root/messages/en.json';
import { useTranslations } from 'next-intl';

type Translations = typeof translations;

const useTranslationsWithMarkup = ({ context }: { context: keyof Translations }) => {
  const translate = useTranslations(context);

  const translateWithMarkup = (key: string) => {
    return translate.rich(key, {
      strong: (translation) => <strong>{translation}</strong>,
    });
  };

  return { translate, translateWithMarkup };
};

export default useTranslationsWithMarkup;
